import { ChartTypes } from '@configs/graph';
import { sortOrders } from '@constants/sort';
import { IReportConfig } from '@typings/reports';

const reportConfig: IReportConfig = {
    reportTitle: 'UTM Метки',
    tableDataType: 'dynamic',
    tableTitle: 'UTM Source, UTM Medium, UTM Campaign, UTM Content, UTM Term',
    defaultSort: {
        name: 'visits',
        order: sortOrders.DESC,
    },
    numberOfGraphs: 'two',
    defaultGraphs: [
        ChartTypes.line,
        ChartTypes.bar,
    ],
    graphDefaultMetrics: [
        'visits',
        'page_views',
    ],
    tableDefaultMetrics: [
        'visits',
        'page_views',
        'avg_view_depth',
    ],
    availableMetrics: [
        'visits',
        'avg_view_depth',
        'page_views',
        'visitors',
        'uid',
        'rambler_id',
        // 'bounces',
        // 'avg_industry_duration',
    ],
    isTableTitleSearch: true,
    isShowTotals: true,
    availableTools: {
        numberOfGraphs: true,
        periodPicker: true,
        sample: true,
        activeSample: true,
        filters: true,
        savedFilters: true,
        detail: true,
    },
    reportHint: {
        message: 'Отчёты агрегируют всю информацию, переданную в метках UTM. Иерархия в отчётах следующая: '
            + 'UTM Source, UTM Medium, UTM Campaign, UTM Content, UTM Term.',
    },
};

export default reportConfig;

